const DEBOUNCE_MS = 300;
let timeout: NodeJS.Timeout = null;
const timeouts: Record<string, NodeJS.Timeout> = {};

export function debounce(callback: () => void, debounceMs = DEBOUNCE_MS): void {
  clearTimeout(timeout);
  timeout = setTimeout(() => callback(), debounceMs);
}

export function debounceWithContext(callback: () => void, identifier?: string, debounceMs = DEBOUNCE_MS): void {
  clearTimeout(timeouts[identifier]);
  timeouts[identifier] = setTimeout(() => callback(), debounceMs);
}